import { handleActions } from 'redux-actions';
import { DamzState } from '../../types';
import {
  clearSearchQuery,
  fetchAutocompleteSearch,
  fetchAutocompleteSearchSuccess,
  initMessageSearchStream,
  fetchMessageSearchSuccess,
  setMessageSearchOrder,
  setIsSearchingMessages,
  closeSearchUI,
} from '../actions/search';

export default handleActions<DamzState['search'], any>(
  {
    [`${clearSearchQuery}`]: state => ({ ...state, q: '', results: [] }),
    [`${closeSearchUI}`]: state => ({
      ...state,
      q: '',
      isSearchingMessages: false,
      results: [],
    }),
    [`${fetchAutocompleteSearch}`]: (
      state,
      action: ReturnType<typeof fetchAutocompleteSearch>
    ) => ({
      ...state,
      q: action.payload.q,
      results: [],
    }),
    [`${fetchAutocompleteSearchSuccess}`]: (
      state,
      action: ReturnType<typeof fetchAutocompleteSearchSuccess>
    ) => ({
      ...state,
      results: action.payload.results,
    }),
    [`${initMessageSearchStream}`]: (
      state,
      action: ReturnType<typeof initMessageSearchStream>
    ) => ({
      ...state,
      q: action.payload.q,
      results: [],
    }),
    [`${fetchMessageSearchSuccess}`]: (
      state,
      action: ReturnType<typeof fetchMessageSearchSuccess>
    ) => ({
      ...state,
      results: action.payload.results,
    }),
    [`${setMessageSearchOrder}`]: (
      state,
      action: ReturnType<typeof setMessageSearchOrder>
    ) => ({
      ...state,
      order: action.payload.order === 'newest' ? 'newest' : 'default',
    }),
    [`${setIsSearchingMessages}`]: (
      state,
      action: ReturnType<typeof setIsSearchingMessages>
    ) => ({
      ...state,
      isSearchingMessages: !!action.payload.isSearchingMessages,
    }),
  },
  {
    q: '',
    isSearchingMessages: false,
    order: 'default',
    results: [],
  }
);
